<template>
<div>
    <div class="row search-box">
        <div class="col-md-8 offset-md-1">
            <vueInstant @click-button="clickInput" type="google" :suggestion-attribute="suggestionAttribute" @input="changed" :suggestions="suggestions" v-model="val"></vueInstant>
        </div>
    </div>

    <div class="row">
      <div class="col-md-12">
      <div class="jumbotron jumbotron-fluid">
        <div class="container">
          <h1 class="display-5" style="color:white;">VUE INSTANT</h1>
          <p class="lead">vue instant allows you to easily create custom search controls with auto suggestions for your vue 2 application.</p>
          <div>
          <a href="https://www.npmjs.com/package/vue-instant"><img src="https://img.shields.io/npm/dt/vue-instant.svg" alt="downloads"></a>
          <a href="https://www.npmjs.com/package/vue-instant"><img src="https://img.shields.io/npm/v/vue-instant.svg" alt="Version"></a>
          <a href="https://www.npmjs.com/package/vue-instant"> <img src="https://img.shields.io/npm/l/vue-instant.svg" alt="License"></a>
          </div>
        </div>
      </div>
      </div>
    </div>


    <div class="row example-row">
        <div class="col-md-8 offset-md-2">
          <h4>Installation</h4>
        <vue-markdown :typographer="true">
```
npm install --save vue-instant
```
        </vue-markdown>


        <vue-markdown :typographer="true">
Distribution import
```javascript
import 'vue-instant/dist/vue-instant.css'
import VueInstant from 'vue-instant/dist/vue-instant.common'
Vue.use(VueInstant)
```
        </vue-markdown>

        Browser support
            <div class="script-colors">
                <div>
                    <code>
                    &lt;script src="vue.js"></script>
                    </code>
                </div>
                <div>
                    <code>
                    &lt;script src="vue-instant/dist/vue-instant.browser.js"></script>
                    </code>
                </div>
          </div>
        </div>
    </div>

    <div class="row example-row">
      <div class="col-md-8 offset-md-2">
            <h4>Example
              <small><a target="_blank" href="https://jsfiddle.net/santiblanko/dqo6vr57/">Fiddle</a></small>
            </h4>
            <div class="example-title-text">
              <pre class="black-color">try typing a film</pre>
            </div>
            <div>
                  <vueInstant class="row amazon-bg" type="amazon" :suggestion-attribute="suggestionAttribute" placeholder="type your favorite film..." @selected="setInstantData"  @input="changed" :suggestions="suggestions" v-model="val"></vueInstant>
            </div>

            <pre class="json-format">{{instantData}}</pre>

      </div>
    </div>

    <div class="row example-row">
      <div class="col-md-8 offset-md-2">
            <h4>Styles</h4>
            <div class="styles-box">
              <div>
                <el-button @click="changeType('google')"  size="mini" type="danger">Google</el-button>
                <el-button @click="changeType('facebook')"  size="mini" type="primary">Facebook</el-button>
                <el-button @click="changeType('amazon')"  size="mini" type="warning">Amazon</el-button>
                <el-button @click="changeType('spotify')"  size="mini" type="success">Spotify</el-button>
                <el-button @click="changeType('twitter')"  size="mini" type="info">Twitter</el-button>
                <div></div>
                <small><a target="_blank" href="http://shipow.github.io/searchbox/"> You can create your own style in this external page!</a></small>
              </div>
            </div>
            <div class="row" :style="getStyle">
                  <vueInstant :type="exampleType" :suggestion-attribute="suggestionAttribute" placeholder="type your favorite film..." @selected="setInstantData"  @input="changed" :suggestions="suggestions" v-model="val"></vueInstant>
            </div>
      </div>
    </div>




<div class="row example-row">
    <div class="col-md-8 offset-md-2">
        <h4>Attributes</h4>
        <table class="table table-bordered">
          <thead>
            <tr class="bg-inverse">
              <td>Attribute</td>
              <td>Description</td>
              <td>type</td>
              <td>Required</td>
              <td>Default</td>
              <td>Accepted values</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>v-model</td>
              <td>binding the component value.</td>
              <td>String</td>
              <td>true</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>suggestions</td>
              <td>collection of suggestions that appear while the user is typing</td>
              <td>Array</td>
              <td>true</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>suggestion-attribute</td>
              <td>The attribute name of the object to render in the searchbox</td>
              <td>string</td>
              <td>true</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>type</td>
              <td>The style of the input</td>
              <td>String</td>
              <td>false</td>
              <td>facebook</td>
              <td>['google', 'facebook', 'twitter', 'amazon', 'spotify', 'custom']</td>
            </tr>
            <tr>
              <td>show-autocomplete</td>
              <td>only show suggests, or suggests with autocomplete.</td>
              <td>Boolean</td>
              <td>true</td>
              <td>full</td>
              <td>-</td>
            </tr>
            <tr>
              <td>placeholder</td>
              <td>same as placeholder in native input</td>
              <td>String</td>
              <td>false</td>
              <td>write something...</td>
              <td>-</td>
            </tr>
            <tr>
              <td>name</td>
              <td>same as name in native input  </td>
              <td>String</td>
              <td>false</td>
              <td>vueInstant</td>
              <td>-</td>
            </tr>
            <tr>
              <td>autofocus</td>
              <td>same as autofocus in native input</td>
              <td>Boolean</td>
              <td>true</td>
              <td>false</td>
              <td>-</td>
            </tr>
            <tr>
              <td>disabled</td>
              <td>same as disabled in native input</td>
              <td>Boolean</td>
              <td>false</td>
              <td>false</td>
              <td>-</td>
            </tr>
          </tbody>
        </table>
    </div>
</div>


<div class="row example-row">
    <div class="col-md-8 offset-md-2">
        <h4>Events</h4>
        <table class="table">
          <thead>
            <tr class="bg-inverse">
              <td>Event</td>
              <td>Description</td>
              <td>Event Data</td>
            </tr>
          </thead>
          <tbody>
           <tr>
              <td>@input</td>
              <td>triggers when the value changes</td>
              <td>(value: string)</td>
            </tr>
            <tr>
              <td>@click-input</td>
              <td>triggers when the text input is clicked</td>
              <td>(event: Event)</td>
            </tr>
            <tr>
              <td>@click-button</td>
              <td>triggers when the submit button is clicked</td>
              <td>(value: string)</td>
            </tr>
            <tr>
              <td>@selected</td>
              <td>triggers when the selectedObject changes</td>
              <td>(selected: obj)</td>
            </tr>
            <tr>
              <td>@enter</td>
              <td>triggers when the enter key is pressed</td>
              <td>(selected: obj)</td>
            </tr>
            <tr>
              <td>@key-up</td>
              <td>triggers when the arrowup key is pressed</td>
              <td>(selected: obj)</td>
            </tr>
            <tr>
              <td>@key-down</td>
              <td>triggers when the arrowdown key is pressed</td>
              <td>(selected: obj)</td>
            </tr>
            <tr>
              <td>@key-right</td>
              <td>triggers when the arrowright key is pressed</td>
              <td>(selected: obj)</td>
            </tr>
            <tr>
              <td>@clear</td>
              <td>triggers when the clear button is pressed</td>
              <td>-</td>
            </tr>
            <tr>
              <td>@escape</td>
              <td>triggers when the escape key is pressed</td>
              <td>(event: Event)</td>
            </tr>
          </tbody>
        </table>
    </div>
</div>


<div class="row example-row">
    <div class="col-md-8 offset-md-2">
        <h4>Custom Box</h4>

        <p>You can override the styles and customize the searchbox. It's easy.
        <p>1. You need define the <code class="highlighted">type</code> prop with the 'custom' value</p>
        <p>2. The next step is go to <a href="http://shipow.github.io/searchbox/">
        http://shipow.github.io/searchbox/</a> and generate your own style or create your own inspired in shipow code.</p>
        <p>3. Copy the css generated in your css file.</p>
        <p>4. Create a new css class called .sbx-custom__input-placeholder with the same properties of the class called ".sbx-custom__input".</p>
        <p>5. Add this class in your css with your autocomplete background and your autocomplete color.</p>

        <vue-markdown :typographer="true">
```css
.vue-instant__suggestions li.highlighted__custom {
  background-color: "your decision";
  color: "your decision";
}
.vue-instant__suggestions {
  margin-top: "your decision";
}
```
          </vue-markdown>

    </div>
</div>



<div class="row example-row">
      <div class="col-md-8 offset-md-2">
                    <a class="github-button" href="https://github.com/santiblanko/vue-instant" data-count-href="/santiblanko/vue-instant/stargazers" data-count-api="/repos/santiblanko/vue-instant#stargazers_count" data-count-aria-label="# stargazers on GitHub" aria-label="Star santiblanko/vue-instant on GitHub">Star</a>
                    <a class="github-button" href="https://github.com/santiblanko/vue-instant/fork" data-count-href="/santiblanko/vue-instant/network" data-count-api="/repos/santiblanko/vue-instant#forks_count" data-count-aria-label="# forks on GitHub" aria-label="Fork santiblanko/vue-instant on GitHub">Fork</a>
                    <a class="github-button" href="https://github.com/santiblanko" data-count-href="/santiblanko/followers" data-count-api="/users/santiblanko#followers" data-count-aria-label="# followers on GitHub" aria-label="Follow @santiblanko on GitHub">Follow @santiblanko</a>
                    <a class="github-button" href="https://github.com/santiblanko/vue-instant/archive/master.zip" aria-label="Download santiblanko/vue-instant on GitHub">Download</a>
                    <a class="github-button" href="https://github.com/santiblanko/vue-instant/issues" data-count-api="/repos/santiblanko/vue-instant#open_issues_count" data-count-aria-label="# issues on GitHub" aria-label="Issue santiblanko/vue-instant on GitHub">Issue</a>
                    <a class="github-button" href="https://github.com/santiblanko/vue-instant/subscription" data-count-href="/santiblanko/vue-instant/watchers" data-count-api="/repos/santiblanko/vue-instant#subscribers_count" data-count-aria-label="# watchers on GitHub" aria-label="Watch santiblanko/vue-instant on GitHub">Watch</a>
      </div>
  </div>

    <a href="https://github.com/santiblanko/vue-instant"><img style="position: absolute; top: 0; right: 0; border: 0; z-index:999;" src="https://camo.githubusercontent.com/652c5b9acfaddf3a9c326fa6bde407b87f7be0f4/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6f72616e67655f6666373630302e706e67" alt="Fork me on GitHub" data-canonical-src="https://s3.amazonaws.com/github/ribbons/forkme_right_orange_ff7600.png"></a>
<link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro" rel="stylesheet">
<footer class="footer"><small>Released under the <a  href="https://opensource.org/licenses/MIT" target="_blank">MIT License</a><br>Copyright © 2017 Santiago Blanco <a href="http://twitter.com/santiblanko">(@santiblanko)</a></small></footer>

</div>
</template>

<script>
import axios from 'axios'
import vueInstant from './can.vue'
import VueMarkdown from 'vue-markdown'
import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
Vue.use(ElementUI)
export default {

  name: 'builder',
  components: {
    vueInstant,
    VueMarkdown
  },
  computed: {
    getStyle () {
      return this.styles[this.exampleType].properties
    }
  },
  methods: {
    clickInput () {
      console.log('hizo click')
    },
    setInstantData (o) {
      this.instantData = o
    },
    changeType (type) {
      this.exampleType = type
    },
    changed () {
      var that = this
      this.suggestions = []
      axios.get('https://api.themoviedb.org/3/search/movie?api_key=342d3061b70d2747a1e159ae9a7e9a36&query=' + this.val)
        .then(function (response) {
          response.data.results.forEach(function (a) {
            that.suggestions.push(a)
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  data () {
    return {
      valStyles: '',
      typographer: true,
      suggestionAttribute: 'original_title',
      instantData: [],
      exampleType: 'amazon',
      val: '',
      styles: {
        facebook: {
          properties: 'background:#3e5da0; padding:10px;'
        },
        twitter: {
          properties: 'background:#fff; padding:10px;'
        },
        spotify: {
          properties: 'background:black; padding:10px;'
        },
        amazon: {
          properties: 'background:#202f40; padding:10px;'
        },
        google: {
          properties: 'background:white; padding:10px;'
        },
        custom: {
          properties: 'background:white; padding:10px;'
        }
      },
      type: 'google',
      suggestions: []
    }
  }
}
</script>
<style>
  body {
    overflow-x: hidden;
    font-family: 'Source Sans Pro', sans-serif !important;
    background-color: #F3F4F7;
  }

  footer {
      padding: 2rem;
      color: #fff;
      background: #202f40;
      text-align: center;
  }

  footer a {
    color:#43ff00;
  }

  footer a:hover {
    color:#43ff00;
  }

  .container {
    margin-top:50px;
  }

  .changer {
    cursor:pointer;
    color:blue;
  }

  .changer:hover {
    cursor:pointer;
  }

  .example-row {
    margin-top:40px;
  }

  .jumbotron {
    background:#202f40 !important;
  }

  .search-box {
    background: white;
    padding: 10px;
  }

  .script-colors {
    background:#f5f2f0;
    padding:10px;
    color:#DD4A68;
  }

  .highlighted {
    background:rgba(255, 255, 0, 0.24);
  }

  .bg-inverse {
    color:white;
  }

  .styled-box {
    color:#FFF;
  }

  .json-format {
    font-size: 10px;
  }

  .amazon-bg {
    background: #202f40;
    padding: 10px;
  }

  .black-color {
    color: black;
  }

  .example-title-text {
    margin-bottom:10px;
  }

  .lead {
    color:white;
  }

</style>



// WEBPACK FOOTER //
// builder.vue?b94f278a